import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DatePicker } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';
import ManufacturerWriteDTO from '../../../../../../types/manufacturer/ManufacturerWriteDTO';
import { ManufacturerService } from '../../../../services/manufacturer.service';
import { UtilsService } from '../../../../services/utils.service';

@Component({
    selector: 'app-update-manufacturer-dialog',
    templateUrl: './update-manufacturer-dialog.component.html',
    styleUrls: [ './update-manufacturer-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        DatePicker,
        Textarea,
        IftaLabelModule,
    ]
})
export class UpdateManufacturerDialogComponent implements OnInit, OnChanges {
    @Input() visible: boolean = false;
    @Input() manufacturer: ManufacturerWriteDTO = new ManufacturerWriteDTO({});
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() manufacturerUpdated: EventEmitter<any> = new EventEmitter<any>();

    public contractExpirationDate: Date | undefined;
    public loading: boolean = false;

    constructor(
        private manufacturerService: ManufacturerService,
        private messageService: MessageService,
        private utilsService: UtilsService
    ) {
    }

    public ngOnInit(): void {
        this.initializeFields();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['manufacturer'] && changes['manufacturer'].currentValue) {
            this.initializeFields();
        }
    }

    private initializeFields(): void {
        this.contractExpirationDate =
            this.utilsService.convertDateStringToDate(this.manufacturer.contractExpirationDate);
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public updateManufacturer(): void {
        this.loading = true;

        this.manufacturer.contractExpirationDate =
            this.utilsService.convertDateToDateString(this.contractExpirationDate);

        this.manufacturerService
            .updateManufacturer(this.manufacturer)
            .then(() => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Manufacturer updated successfully',
                    life: 3000,
                });
                this.manufacturerUpdated.emit();
                this.close();
            })
            .catch((error: any) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 6000,
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
